var r = typeof window == "object" && window.window === window ? window : typeof self == "object" && self.self === self ? self : typeof global == "object" && global.global === global ? global : void 0;
function y(n, e) {
  return typeof e > "u" ? e = { autoBom: !1 } : typeof e != "object" && (console.warn("Deprecated: Expected third argument to be a object"), e = { autoBom: !e }), e.autoBom && /^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(n.type) ? new Blob(["\uFEFF", n], { type: n.type }) : n;
}
function d(n, e, a) {
  var o = new XMLHttpRequest();
  o.open("GET", n), o.responseType = "blob", o.onload = function() {
    u(o.response, e, a);
  }, o.onerror = function() {
    console.error("could not download file");
  }, o.send();
}
function g(n) {
  var e = new XMLHttpRequest();
  e.open("HEAD", n, !1);
  try {
    e.send();
  } catch {
  }
  return e.status >= 200 && e.status <= 299;
}
function c(n) {
  try {
    n.dispatchEvent(new MouseEvent("click"));
  } catch {
    var e = document.createEvent("MouseEvents");
    e.initMouseEvent(
      "click",
      !0,
      !0,
      window,
      0,
      0,
      0,
      80,
      20,
      !1,
      !1,
      !1,
      !1,
      0,
      null
    ), n.dispatchEvent(e);
  }
}
var m = r.navigator && /Macintosh/.test(navigator.userAgent) && /AppleWebKit/.test(navigator.userAgent) && !/Safari/.test(navigator.userAgent), u = r.saveAs || // probably in some web worker
(typeof window != "object" || window !== r ? function() {
} : "download" in HTMLAnchorElement.prototype && !m ? function(e, a, o) {
  var t = r.URL || r.webkitURL, i = document.createElement("a");
  a = a || e.name || "download", i.download = a, i.rel = "noopener", typeof e == "string" ? (i.href = e, i.origin !== location.origin ? g(i.href) ? d(e, a, o) : c(i, i.target = "_blank") : c(i)) : (i.href = t.createObjectURL(e), setTimeout(function() {
    t.revokeObjectURL(i.href);
  }, 4e4), setTimeout(function() {
    c(i);
  }, 0));
} : "msSaveOrOpenBlob" in navigator ? function(e, a, o) {
  if (a = a || e.name || "download", typeof e == "string")
    if (g(e))
      d(e, a, o);
    else {
      var t = document.createElement("a");
      t.href = e, t.target = "_blank", setTimeout(function() {
        c(t);
      });
    }
  else
    navigator.msSaveOrOpenBlob(y(e, o), a);
} : function(e, a, o, t) {
  if (t = t || open("", "_blank"), t && (t.document.title = t.document.body.innerText = "downloading..."), typeof e == "string")
    return d(e, a, o);
  var i = e.type === "application/octet-stream", h = /constructor/i.test(r.HTMLElement) || r.safari, v = /CriOS\/[\d]+/.test(navigator.userAgent);
  if ((v || i && h || m) && typeof FileReader < "u") {
    var f = new FileReader();
    f.onloadend = function() {
      var s = f.result;
      s = v ? s : s.replace(/^data:[^;]*;/, "data:attachment/file;"), t ? t.location.href = s : location = s, t = null;
    }, f.readAsDataURL(e);
  } else {
    var w = r.URL || r.webkitURL, l = w.createObjectURL(e);
    t ? t.location = l : location.href = l, t = null, setTimeout(function() {
      w.revokeObjectURL(l);
    }, 4e4);
  }
});
r.saveAs = u.saveAs = u;
export {
  u as default
};
//# sourceMappingURL=file-system-x0nkVouZ.mjs.map
